<template>
  <section
    id="device-statistics"
    :dir="$functions.currentLangDirection()"
  >
    <b-card class="admin-page-mobile">
      <h2 class="mb-4">
        آمار دستگاه‌ها
      </h2>

      <!-- Loading State -->
      <div
        v-if="loading"
        class="text-center py-5"
      >
        <b-spinner
          variant="primary"
          label="در حال بارگذاری..."
        />
        <p class="mt-2">
          در حال دریافت آمار...
        </p>
      </div>

      <!-- Statistics Content -->
      <div v-else>
        <!-- آمار کلی -->
        <h3 class="section-title">
          آمار کلی دستگاه‌ها
        </h3>
        <b-row class="stats-section">
          <b-col
            cols="12"
            md="6"
            lg="3"
            class="mb-3"
          >
            <div
              class="stat-card primary clickable"
              @click="navigateToDevices('all')"
            >
              <div class="stat-content">
                <div class="stat-value">
                  {{ statistics.overview.total }}
                </div>
                <div class="stat-label">
                  تعداد کل دستگاه‌ها
                </div>
              </div>
              <div
                class="info-button"
                @click.stop="showDescription('total')"
              >
                <feather-icon
                  icon="InfoIcon"
                  size="16"
                />
                <span>جزئیات</span>
              </div>
            </div>
          </b-col>

          <b-col
            cols="12"
            md="6"
            lg="3"
            class="mb-3"
          >
            <div
              class="stat-card success clickable"
              @click="navigateToDevices('assigned')"
            >
              <div
                class="info-button"
                @click.stop="showDescription('installed')"
              >
                <feather-icon
                  icon="InfoIcon"
                  size="16"
                />
                <span>جزئیات</span>
              </div>
              <div class="stat-content">
                <div class="stat-value">
                  {{ installedDevices }}
                </div>
                <div class="stat-label">
                  دستگاه‌های نصب شده
                </div>
              </div>
            </div>
          </b-col>

          <b-col
            cols="12"
            md="6"
            lg="3"
            class="mb-3"
          >
            <div
              class="stat-card danger clickable"
              @click="navigateToDevices('disabled')"
            >
              <div
                class="info-button"
                @click.stop="showDescription('disabled')"
              >
                <feather-icon
                  icon="InfoIcon"
                  size="16"
                />
                <span>جزئیات</span>
              </div>
              <div class="stat-content">
                <div class="stat-value">
                  {{ statistics.overview.disabled }}
                </div>
                <div class="stat-label">
                  دستگاه‌های غیرفعال
                </div>
              </div>
            </div>
          </b-col>

          <b-col
            cols="12"
            md="6"
            lg="3"
            class="mb-3"
          >
            <div
              class="stat-card warning clickable"
              @click="navigateToDevices('expired')"
            >
              <div
                class="info-button"
                @click.stop="showDescription('expired')"
              >
                <feather-icon
                  icon="InfoIcon"
                  size="16"
                />
                <span>جزئیات</span>
              </div>
              <div class="stat-content">
                <div class="stat-value">
                  {{ statistics.overview.expired }}
                </div>
                <div class="stat-label">
                  دستگاه‌های منقضی شده
                </div>
              </div>
            </div>
          </b-col>

          <b-col
            cols="12"
            md="6"
            lg="3"
            class="mb-3"
          >
            <div
              class="stat-card info clickable"
              @click="navigateToDevices('expiredButActive')"
            >
              <div
                class="info-button"
                @click.stop="showDescription('expiredButActive')"
              >
                <feather-icon
                  icon="InfoIcon"
                  size="16"
                />
                <span>جزئیات</span>
              </div>
              <div class="stat-content">
                <div class="stat-value">
                  {{ statistics.overview.expiredButActive }}
                </div>
                <div class="stat-label">
                  منقضی شده در حال استفاده
                </div>
              </div>
            </div>
          </b-col>

          <b-col
            cols="12"
            md="6"
            lg="3"
            class="mb-3"
          >
            <div
              class="stat-card secondary clickable"
              @click="navigateToDevices('expiredAndDisabled')"
            >
              <div
                class="info-button"
                @click.stop="showDescription('expiredAndDisabled')"
              >
                <feather-icon
                  icon="InfoIcon"
                  size="16"
                />
                <span>جزئیات</span>
              </div>
              <div class="stat-content">
                <div class="stat-value">
                  {{ statistics.overview.expiredAndDisabled }}
                </div>
                <div class="stat-label">
                  منقضی شده بدون استفاده
                </div>
              </div>
            </div>
          </b-col>

          <b-col
            cols="12"
            md="6"
            lg="3"
            class="mb-3"
          >
            <div
              class="stat-card success clickable"
              @click="navigateToDevices('assigned')"
            >
              <div
                class="info-button"
                @click.stop="showDescription('assigned')"
              >
                <feather-icon
                  icon="InfoIcon"
                  size="16"
                />
                <span>جزئیات</span>
              </div>
              <div class="stat-content">
                <div class="stat-value">
                  {{ statistics.overview.assigned }}
                </div>
                <div class="stat-label">
                  دستگاه‌های واگذار شده
                </div>
              </div>
            </div>
          </b-col>

          <b-col
            cols="12"
            md="6"
            lg="3"
            class="mb-3"
          >
            <div
              class="stat-card warning clickable"
              @click="navigateToDevices('unassigned')"
            >
              <div
                class="info-button"
                @click.stop="showDescription('unassigned')"
              >
                <feather-icon
                  icon="InfoIcon"
                  size="16"
                />
                <span>جزئیات</span>
              </div>
              <div class="stat-content">
                <div class="stat-value">
                  {{ statistics.overview.unassigned }}
                </div>
                <div class="stat-label">
                  دستگاه‌های بدون کاربر
                </div>
              </div>
            </div>
          </b-col>
        </b-row>

        <!-- آمار زمانی -->
        <h3 class="section-title mt-5">
          آمار زمانی و اعتبار
        </h3>

        <h4 class="subsection-title">
          دستگاه‌های منقضی شده بر اساس زمان
        </h4>
        <b-row class="stats-section">
          <b-col
            cols="12"
            md="6"
            lg="3"
            class="mb-3"
          >
            <div
              class="stat-card time-expired clickable"
              @click="navigateToDevices('expiredLast1Month')"
            >
              <div
                class="info-button"
                @click.stop="showDescription('expiredLast1Month')"
              >
                <feather-icon
                  icon="InfoIcon"
                  size="16"
                />
                <span>جزئیات</span>
              </div>
              <div class="stat-content">
                <div class="stat-value">
                  {{ statistics.timeStats.expiredLast1Month }}
                </div>
                <div class="stat-label">
                  منقضی شده در 1 ماه گذشته
                </div>
              </div>
            </div>
          </b-col>

          <b-col
            cols="12"
            md="6"
            lg="3"
            class="mb-3"
          >
            <div
              class="stat-card time-expired clickable"
              @click="navigateToDevices('expiredLast3Months')"
            >
              <div
                class="info-button"
                @click.stop="showDescription('expiredLast3Months')"
              >
                <feather-icon
                  icon="InfoIcon"
                  size="16"
                />
                <span>جزئیات</span>
              </div>
              <div class="stat-content">
                <div class="stat-value">
                  {{ statistics.timeStats.expiredLast3Months }}
                </div>
                <div class="stat-label">
                  منقضی شده در 3 ماه گذشته
                </div>
              </div>
            </div>
          </b-col>

          <b-col
            cols="12"
            md="6"
            lg="3"
            class="mb-3"
          >
            <div
              class="stat-card time-expired clickable"
              @click="navigateToDevices('expiredLast6Months')"
            >
              <div
                class="info-button"
                @click.stop="showDescription('expiredLast6Months')"
              >
                <feather-icon
                  icon="InfoIcon"
                  size="16"
                />
                <span>جزئیات</span>
              </div>
              <div class="stat-content">
                <div class="stat-value">
                  {{ statistics.timeStats.expiredLast6Months }}
                </div>
                <div class="stat-label">
                  منقضی شده در 6 ماه گذشته
                </div>
              </div>
            </div>
          </b-col>

          <b-col
            cols="12"
            md="6"
            lg="3"
            class="mb-3"
          >
            <div
              class="stat-card time-expired clickable"
              @click="navigateToDevices('expiredMoreThan6Months')"
            >
              <div
                class="info-button"
                @click.stop="showDescription('expiredMoreThan6Months')"
              >
                <feather-icon
                  icon="InfoIcon"
                  size="16"
                />
                <span>جزئیات</span>
              </div>
              <div class="stat-content">
                <div class="stat-value">
                  {{ statistics.timeStats.expiredMoreThan6Months }}
                </div>
                <div class="stat-label">
                  منقضی شده بیش از 6 ماه
                </div>
              </div>
            </div>
          </b-col>
        </b-row>

      </div>
    </b-card>

    <!-- Description Modal -->
    <b-modal
      id="description-modal"
      ref="descriptionModal"
      :title="descriptionTitle"
      centered
      ok-only
      ok-title="متوجه شدم"
      ok-variant="primary"
    >
      <p
        class="description-text"
        v-html="descriptionText"
      />
    </b-modal>
  </section>
</template>

<script>
import {
  BRow, BCol, BCard, BSpinner, BModal,
} from 'bootstrap-vue'
import DeviceService from '@/services/device.service'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BSpinner,
    BModal,
  },
  data() {
    return {
      loading: false,
      descriptionTitle: '',
      descriptionText: '',
      statistics: {
        overview: {
          total: 0,
          active: 0,
          disabled: 0,
          expired: 0,
          expiredButActive: 0,
          expiredAndDisabled: 0,
          assigned: 0,
          unassigned: 0,
        },
        timeStats: {
          expiredLast1Month: 0,
          expiredLast3Months: 0,
          expiredLast6Months: 0,
          expiredMoreThan6Months: 0,
          expiredLast1MonthActive: 0,
          expiredLast3MonthsActive: 0,
          expiredLast6MonthsActive: 0,
          expiredMoreThan6MonthsActive: 0,
        },
      },
      descriptions: {
        total: {
          title: 'تعداد کل دستگاه‌ها',
          text: 'این عدد نشان‌دهنده <strong>تعداد کل دستگاه‌های ثبت شده</strong> در سیستم است که شامل:<br><br>• دستگاه‌های فعال و غیرفعال<br>• دستگاه‌های منقضی شده و معتبر<br>• دستگاه‌های واگذار شده به کاربر و بدون کاربر<br><br>این آمار قابل افزایش دستی است.',
        },
        installed: {
          title: 'دستگاه‌های نصب شده',
          text: '<strong>دستگاه‌هایی که نزد کاربر نصب شده و فعال هستند</strong>.<br><br>محاسبه: تعداد کل - دستگاه‌های بدون کاربر<br><br>این دستگاه‌ها:<br>• به کاربر اختصاص داده شده‌اند (userId دارند)<br>• روی خودرو نصب شده‌اند<br>• ممکن است منقضی شده یا معتبر باشند',
        },
        disabled: {
          title: 'دستگاه‌های غیرفعال',
          text: '<strong>دستگاه‌هایی که به صورت دستی غیرفعال شده‌اند</strong> (disabled = true).<br><br>دلایل غیرفعال شدن:<br>• ایراد فنی<br>• دستور شرکت<br>• درخواست کاربر<br>• مشکلات امنیتی',
        },
        expired: {
          title: 'دستگاه‌های منقضی شده',
          text: '<strong>دستگاه‌هایی که تاریخ اعتبارشان گذشته است</strong>.<br><br>محاسبه: تاریخ امروز > تاریخ انقضای دستگاه<br><br>این شامل:<br>• دستگاه‌های منقضی که هنوز فعال هستند<br>• دستگاه‌های منقضی که غیرفعال شده‌اند',
        },
        expiredButActive: {
          title: 'منقضی شده در حال استفاده',
          text: '<strong>دستگاه‌هایی که تاریخ اعتبارشان گذشته اما هنوز فعال هستند</strong>.<br><br>شرایط:<br>• تاریخ امروز > تاریخ انقضا<br>• وضعیت فعال (disabled = false)<br>• کاربر دارای اکانت است<br><br>⚠️ این دستگاه‌ها نیاز به شارژ و تمدید اعتبار دارند.',
        },
        expiredAndDisabled: {
          title: 'منقضی شده بدون استفاده',
          text: '<strong>دستگاه‌هایی که هم منقضی شده و هم غیرفعال شده‌اند</strong>.<br><br>شرایط:<br>• تاریخ امروز > تاریخ انقضا<br>• وضعیت غیرفعال (disabled = true)<br><br>این دستگاه‌ها به دلیل عدم تمدید یا مشکلات فنی غیرفعال شده‌اند.',
        },
        assigned: {
          title: 'دستگاه‌های واگذار شده',
          text: '<strong>دستگاه‌هایی که به یک کاربر اختصاص داده شده‌اند</strong>.<br><br>محاسبه: دستگاه‌هایی که userId آنها پر شده است<br><br>این دستگاه‌ها:<br>• توسط یک کاربر مشخص استفاده می‌شوند<br>• به خودرو نصب شده‌اند<br>• اکانت فعال دارند',
        },
        unassigned: {
          title: 'دستگاه‌های بدون کاربر',
          text: '<strong>دستگاه‌هایی که به هیچ کاربری واگذار نشده‌اند</strong>.<br><br>محاسبه: کل دستگاه‌ها - دستگاه‌های واگذار شده<br><br>این دستگاه‌ها:<br>• موجودی انبار شرکت یا نمایندگی هستند<br>• در انتظار فروش یا واگذاری<br>• userId ندارند',
        },
        expiredLast1Month: {
          title: 'منقضی شده در 1 ماه گذشته',
          text: '<strong>دستگاه‌هایی که در یک ماه اخیر منقضی شده‌اند</strong>.<br><br>محاسبه: دستگاه‌هایی که تاریخ انقضایشان بین 1 ماه پیش تا امروز است.',
        },
        expiredLast3Months: {
          title: 'منقضی شده در 3 ماه گذشته',
          text: '<strong>دستگاه‌هایی که در سه ماه اخیر منقضی شده‌اند</strong>.<br><br>محاسبه: دستگاه‌هایی که تاریخ انقضایشان بین 3 ماه پیش تا امروز است.',
        },
        expiredLast6Months: {
          title: 'منقضی شده در 6 ماه گذشته',
          text: '<strong>دستگاه‌هایی که در شش ماه اخیر منقضی شده‌اند</strong>.<br><br>محاسبه: دستگاه‌هایی که تاریخ انقضایشان بین 6 ماه پیش تا امروز است.',
        },
        expiredMoreThan6Months: {
          title: 'منقضی شده بیش از 6 ماه',
          text: '<strong>دستگاه‌هایی که بیش از 6 ماه از تاریخ انقضایشان گذشته است</strong>.<br><br>محاسبه: دستگاه‌هایی که تاریخ انقضایشان قبل از 6 ماه پیش است.<br><br>⚠️ این دستگاه‌ها مدت زیادی است که منقضی شده‌اند.',
        },
        expiredLast1MonthActive: {
          title: 'منقضی 1 ماه - در حال استفاده',
          text: '<strong>دستگاه‌های منقضی شده در 1 ماه گذشته که هنوز فعال هستند</strong>.<br><br>شرایط:<br>• تاریخ انقضا بین 1 ماه پیش تا امروز<br>• وضعیت فعال (disabled = false)<br><br>این دستگاه‌ها نیاز فوری به تمدید دارند.',
        },
        expiredLast3MonthsActive: {
          title: 'منقضی 3 ماه - در حال استفاده',
          text: '<strong>دستگاه‌های منقضی شده در 3 ماه گذشته که هنوز فعال هستند</strong>.<br><br>شرایط:<br>• تاریخ انقضا بین 3 ماه پیش تا امروز<br>• وضعیت فعال (disabled = false)',
        },
        expiredLast6MonthsActive: {
          title: 'منقضی 6 ماه - در حال استفاده',
          text: '<strong>دستگاه‌های منقضی شده در 6 ماه گذشته که هنوز فعال هستند</strong>.<br><br>شرایط:<br>• تاریخ انقضا بین 6 ماه پیش تا امروز<br>• وضعیت فعال (disabled = false)',
        },
        expiredMoreThan6MonthsActive: {
          title: 'منقضی +6 ماه - در حال استفاده',
          text: '<strong>دستگاه‌های منقضی شده بیش از 6 ماه که هنوز فعال هستند</strong>.<br><br>شرایط:<br>• تاریخ انقضا قبل از 6 ماه پیش<br>• وضعیت فعال (disabled = false)<br><br>⚠️⚠️ این دستگاه‌ها مدت طولانی است بدون اعتبار استفاده می‌شوند!',
        },
      },
    }
  },
  async created() {
    await this.loadStatistics()
  },
  computed: {
    installedDevices() {
      // دستگاه‌های نصب شده = کل - بدون کاربر
      return this.statistics.overview.total - this.statistics.overview.unassigned
    },
  },
  methods: {
    async loadStatistics() {
      this.loading = true
      try {
        const response = await DeviceService.getStatistics()
        if (response.status === 'success') {
          this.statistics = response.result
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'خطا در دریافت آمار',
              text: 'امکان دریافت آمار وجود ندارد',
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'خطا',
            text: 'مشکلی در دریافت آمار رخ داده است',
            icon: 'XIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.loading = false
      }
    },
    navigateToDevices(filterType) {
      this.$router.push({
        name: 'admin-device-all',
        query: { filter: filterType },
      })
    },
    showDescription(type) {
      const desc = this.descriptions[type]
      if (desc) {
        this.descriptionTitle = desc.title
        this.descriptionText = desc.text
        this.$refs.descriptionModal.show()
      }
    },
  },
}
</script>

<style scoped>
#device-statistics {
  padding: 20px;
}

.section-title {
  font-size: 1.5rem;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 20px;
  border-right: 5px solid #667eea;
  padding-right: 15px;
}

.subsection-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #4a5568;
  margin-bottom: 15px;
  padding-right: 10px;
}

.stats-section {
  margin-bottom: 30px;
}

.stat-card {
  background: white;
  border-radius: 12px;
  padding: 25px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  border-right: 5px solid;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  align-items: center;
  gap: 20px;
  min-height: 120px;
  position: relative;
}

.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.info-button {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  align-items: center;
  gap: 4px;
  color: #667eea;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.3s ease;
  z-index: 10;
  font-size: 0.85rem;
  padding: 4px 8px;
  border-radius: 4px;
  background: rgba(102, 126, 234, 0.1);
}

.info-button:hover {
  opacity: 1;
  background: rgba(102, 126, 234, 0.2);
}

.stat-icon {
  font-size: 3rem;
  flex-shrink: 0;
}

.stat-content {
  flex: 1;
}

.stat-value {
  font-size: 2.5rem;
  font-weight: bold;
  color: #2d3748;
  line-height: 1;
  margin-bottom: 8px;
}

.stat-label {
  font-size: 0.95rem;
  color: #718096;
  font-weight: 500;
}

.description-text {
  font-size: 0.95rem;
  line-height: 1.8;
  color: #2d3748;
}

/* Card color variants */
.stat-card.primary {
  border-color: #4299e1;
}

.stat-card.success {
  border-color: #48bb78;
}

.stat-card.danger {
  border-color: #f56565;
}

.stat-card.warning {
  border-color: #ed8936;
}

.stat-card.info {
  border-color: #9f7aea;
}

.stat-card.secondary {
  border-color: #718096;
}

.stat-card.time-expired {
  border-color: #f6ad55;
}

.stat-card.time-active {
  border-color: #68d391;
}

/* Clickable cards */
.stat-card.clickable {
  cursor: pointer;
  user-select: none;
}

.stat-card.clickable:active {
  transform: translateY(-3px);
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .stat-card {
    padding: 20px;
    min-height: 100px;
  }

  .stat-icon {
    font-size: 2.5rem;
  }

  .stat-value {
    font-size: 2rem;
  }

  .stat-label {
    font-size: 0.85rem;
  }

  .section-title {
    font-size: 1.3rem;
  }

  .subsection-title {
    font-size: 1.1rem;
  }

  .info-button {
    top: 8px;
    right: 8px;
  }
}

/* Dark mode support (if using mobile dark theme) */
.admin-page-mobile[data-theme="dark"] .stat-card {
  background: #2d3748;
}

.admin-page-mobile[data-theme="dark"] .stat-value {
  color: #e2e8f0;
}

.admin-page-mobile[data-theme="dark"] .stat-label {
  color: #cbd5e0;
}

.admin-page-mobile[data-theme="dark"] .section-title {
  color: #e2e8f0;
}

.admin-page-mobile[data-theme="dark"] .description-text {
  color: #e2e8f0;
}
</style>